import { apiFetch } from '../../../lib/api'
import type { CountryResponse, StoreResponse } from '../StoreLocator.types'

export const getCountriesWithStores = (): Promise<CountryResponse[]> =>
  apiFetch<CountryResponse[]>('/stores/countrieswithstores')

/** Resolves store info from a Waitwhile location id (used in reschedule/cancel). */
export const getStoreDataByLocation = (
  locationId: string,
): Promise<StoreResponse> =>
  apiFetch<StoreResponse>(`/stores/waitwhilelocationid/${locationId}`)
